import { render } from "./customerForm.vue?vue&type=template&id=1501b3fb"
import script from "./customerForm.vue?vue&type=script&lang=js"
export * from "./customerForm.vue?vue&type=script&lang=js"

import "./customerForm.vue?vue&type=style&index=0&id=1501b3fb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__